import {ref} from 'vue';

/**
 * Shared submit guard for the plate/VIN search fields: refuse while disabled, focus the field back
 * instead of emitting when normalizing leaves nothing to search, otherwise hand the normalized
 * value to the caller.
 */
export function useSearchSubmit(
    disabled: () => boolean,
    rawValue: () => string,
    normalize: (raw: string) => string,
    onSubmit: (value: string) => void
) {
    const field = ref<HTMLInputElement | null>(null);

    function submit(): void {
        if (disabled()) {
            return;
        }

        const value = normalize(rawValue());
        if (value === '') {
            field.value?.focus();

            return;
        }

        onSubmit(value);
    }

    return {field, submit};
}
